export default __webpack_public_path__ + "static/media/games.6ffee609.jpg";